<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="档案详情"></el-page-header>
        <div class="detail_box">
            <!--            <div><h1>{{user_name}} —— 档案详情</h1></div>-->
            <div>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">特属服务对象</span>
                            <span class="detail_content">{{ user_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">创建日期</span>
                            <span class="detail_content">{{ create_date }}</span>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">更新日期</span>
                            <span class="detail_content">{{ update_date }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">特属专家</span>
                            <span class="detail_content">{{ doctor_name }}</span>
                        </div>
                    </el-col>
                    <el-col :span="9">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">会面日期</span>
                            <span class="detail_content">{{ meet_date }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">标题</span>
                            <span class="detail_content">{{ title }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple detail_diagnosis">
                            <div class="detail_title">诊断结果</div>
                            <div class="detail_content">{{ diagnosis }}
                                <br />
                                <br />
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="border-bottom: none;">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <span class="detail_title">处置方式</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                        <span class="detail_content">
                            <el-radio-group v-model="dispose_type">
                                <el-radio label="1" disabled>用药</el-radio>
                                <el-radio label="2" disabled>输液</el-radio>
                                <el-radio label="3" disabled>留院观察</el-radio>
                                <el-radio label="4" disabled>住院治疗</el-radio>
                                <el-radio label="5" disabled v-if="dispose_type == 5">其他({{other_dispose_type}})</el-radio>
                                <el-radio label="5" disabled v-else>其他</el-radio>
                            </el-radio-group>
                        </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple detail_diagnosis">
                            <div class="detail_title">特属专家建议</div>
                            <div class="detail_content" style="white-space: pre-line;">
                                {{ describe }}
                                <br />
                                <br />
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="grid-content bg-purple detail_diagnosis">
                            <div class="detail_title">档案图片</div>
                            <div class="detail_content" style="margin-left: 0;">
                                <div>
                                    <ul class="el-upload-list el-upload-list--picture-card">
                                        <li tabindex="0" class="el-upload-list__item is-ready" v-for="(img, index) in fileList">
                                            <div>
                                                <img :src="img.url" alt="" class="el-upload-list__item-thumbnail">
                                                <span class="el-upload-list__item-actions" @click="previewImage(fileList, index)">
                                                    <span class="el-upload-list__item-preview"><i class="el-icon-zoom-in"></i></span>
                                                </span>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-dialog title="档案图片详情" :visible.sync="dialogContractFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="url in imageUrl" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {fileType} from "@/api/order";

export default {
    created() {
        localStorage.setItem('prev_page', 'health_detail')
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getDeta()
        } else {
            this.id = this.$route.params.id;

            this.user_id = this.$route.params.user_id;
            this.describe = this.$route.params.describe;
            this.title = this.$route.params.title;
            this.doctor_name = this.$route.params.doctor_name;
            this.consultation_hospital = this.$route.params.consultation_hospital;
            this.consultation_department = this.$route.params.consultation_department;
            this.user_name = this.$route.params.user_name;
            this.dispose_type = this.$route.params.dispose_type;
            this.other_dispose_type = this.$route.params.other_dispose_type;
            this.diagnosis = this.$route.params.diagnosis;
            this.meet_date = this.changeDate(this.$route.params.meet_date);
            this.create_date = this.$route.params.create_date;
            this.update_date = this.$route.params.update_date;

            if (this.$route.params.images) {
                var allFile = [];
                var imageUrl = [];
                var images = this.$route.params.images.split(',');
                for (var i = 0; i < images.length; i++) {
                    let index = images[i].lastIndexOf("/");
                    let name = images[i].substring(index + 1, images[i].length);
                    let oneContract = {
                        name: name,
                        url: this.imgUrl + images[i]
                    };
                    allFile.push(oneContract);
                }
                this.fileList = allFile;
            }
        }

    },
    mounted() {

    },
    data() {
        return {
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            userAvaratImageUrl: '',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            allUser: [],
            allUserDoctor: [],
            fileList: [],
            imageUrl: [],
            formLabelWidth: '120px',
            id: '',
            is_other_type: false,
            title: '',
            doctor_name: '',
            doctor_id: '',
            user_id: '',
            consultation_hospital: '',
            describe: '',
            consultation_department: '',
            hospital_name: '',
            hospital_id: '',
            user_name: '',
            dispose_type: 0,
            diagnosis: '',
            meet_date: '',
            create_date: '',
            update_date: '',
            other_dispose_type: '',
            dialogContractFormVisible: false,
            active_index: 0,
        };
    },
    methods: {
        previewImage(data, index){
            if (this.$refs.image_box) {
                this.$refs.image_box.setActiveItem(index)
            }
            this.imageUrl = [];

            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {

                    this.imageUrl.push(data[i].url);
                }
            }
            this.active_index = index
            this.dialogContractFormVisible = true;

        },
        changeDate(d) {
            let time = new Date(d);
            let y = time.getFullYear();
            let m = time.getMonth() + 1;
            let D = time.getDate();

            return `${y}年${m}月${D}日`
        },

        getDeta() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'userHealthrecordsDetail',
                params: {
                    id: this.id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.user_id = res.data.data.user_id;
                this.describe = res.data.data.describe;
                this.title = res.data.data.title;
                this.doctor_name = res.data.data.doctor_name;
                this.user_name = res.data.data.user_name;
                this.consultation_hospital = res.data.data.consultation_hospital;
                this.consultation_department = res.data.data.consultation_department;
                this.user_info = `${res.data.data.bloc_name}/${res.data.data.user_name}`;
                this.dispose_type = res.data.data.dispose_type;
                this.other_dispose_type = res.data.data.other_dispose_type;
                this.diagnosis = res.data.data.diagnosis;
                this.meet_date = this.changeDate(res.data.data.meet_date);
                this.create_date = res.data.data.create_date;
                this.update_date = res.data.data.update_date;

                if (res.data.data.dispose_type == 5) {
                    this.is_other_type = true;
                }
                if (res.data.data.images) {
                    var allFile = [];
                    var images = res.data.data.images.split(',');
                    for (var i = 0; i < images.length; i++) {
                        let index = images[i].lastIndexOf("/");
                        let name = images[i].substring(index + 1, images[i].length);
                        let oneContract = {
                            name: name,
                            url: this.imgUrl + images[i]
                        };
                        allFile.push(oneContract);
                    }
                    this.fileList = allFile;
                    this.addFileList = images;
                }
            });
        },
        getFileType(url) {
            return fileType(url)
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
        },

    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.detail_box {
    box-sizing: border-box;
    padding: 20px;
    width: 980px;
    margin: 30px auto;
    border: 1px solid #DCDFE6;
    line-height: 4em;

    .el-row {
        border-bottom: 1px solid #DCDFE6;
    }

    .el-row:last-child {
        border-bottom: none;
    }

    .detail_content {
        color: #989898;
        margin-left: 1.5em;
        .el-radio.is-disabled.is-checked{
            .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner{
                border-color: #409EFF;
                background: #409EFF;
            }
        }
        .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
            background-color: #fff;
        }
        .el-radio__label {
            color: #989898 !important;
            font-size: 16px;
        }
    }

    .detail_diagnosis {
        text-align: left;
        .detail_content {
            line-height: 1.5em;
        }

    }
}

.el-carousel__indicators.el-carousel__indicators--horizontal.el-carousel__indicators--outside{display: none}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}

.user_search {
    text-align: left;
    width: 100%;
}
</style>
